
import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';
import { navigateAndScrollTo } from '@/utils/scrollUtils';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [logoVisible, setLogoVisible] = useState(false);
  const location = useLocation();
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const t = useTranslation();

  const handleServicesClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsMenuOpen(false);
    navigateAndScrollTo('workflow');
  };


  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    const timer = setTimeout(() => setLogoVisible(true), 50);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className={cn("fixed top-0 left-0 right-0 z-50 transition-all duration-300", scrolled ? "bg-background/80 backdrop-blur-md shadow-md border-b border-white/5" : "bg-transparent")}>
      <div className="container px-4 sm:px-6 lg:px-8 mx-auto">
        <div className="relative flex h-20 items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center group">
              <img 
                src="/lovable-uploads/302515c5-7391-4a01-9649-064e9325fd8f.png" 
                alt="Klexu Logo" 
                width="163"
                height="40"
                className={`h-10 mr-3 group-hover:scale-110 transition-all duration-300 ${logoVisible ? 'opacity-100' : 'opacity-0'}`}
                style={{ transitionDuration: '200ms' }}
              />
            </Link>
          </div>
          
          {/* Desktop Navigation — centered */}
          <nav className="hidden md:flex absolute left-1/2 -translate-x-1/2 items-center space-x-10">
            <a href="#" onClick={handleServicesClick} className="text-sm font-medium text-foreground/80 hover:text-foreground/100 transition-colors">{t.navigation.services}</a>

            <Link to="/about" className="text-sm font-medium text-foreground/80 hover:text-foreground/100 transition-colors">About Us</Link>

            <Link to="/consultation" className="text-sm font-medium text-foreground/80 hover:text-foreground/100 transition-colors">Contact</Link>
          </nav>
          
          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button className="text-white p-2 focus:outline-none" onClick={toggleMenu} aria-label="Toggle Menu">
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile Navigation */}
      <div className={cn("md:hidden fixed inset-x-0 top-20 bg-background/95 backdrop-blur-md border-b border-white/10 shadow-lg transition-all duration-300 ease-in-out overflow-hidden", isMenuOpen ? "max-h-[80vh] overflow-y-auto" : "max-h-0")}>
        <div className="px-6 py-6 space-y-4">
          <a href="#" onClick={handleServicesClick} className="block text-base font-medium text-foreground/80 hover:text-foreground/100 transition-colors">
            {t.navigation.services}
          </a>

          <Link to="/about" className="block text-base font-medium text-foreground/80 hover:text-foreground/100 transition-colors">
            About Us
          </Link>

          <Link to="/consultation" className="block text-base font-medium text-foreground/80 hover:text-foreground/100 transition-colors">
            Contact
          </Link>
        </div>
      </div>
    </header>
  );
};
export default Navbar;